import { render, staticRenderFns } from "./Web3CheckIcon.vue?vue&type=template&id=03942376&"
import script from "./Web3CheckIcon.vue?vue&type=script&lang=ts&"
export * from "./Web3CheckIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports